import { useCallback, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import usePolling from 'hooks/usePolling';
import { gradingOverviewRefreshState, gradingOverviewState } from 'states/GradingOverview';
import { useGradingAcademy } from './gradingAccess';
import { fetchOverview, problemDetailOf } from './gradingApi';
import { overviewIntervalOf } from './gradingRefresh';

const SERVER_CACHE_SETTLED_MS = 6 * 1000;

const GradingOverviewSync = () => {
  const academyId = useGradingAcademy()?.id ?? null;
  const setOverview = useSetRecoilState(gradingOverviewState);
  const refreshRequests = useRecoilValue(gradingOverviewRefreshState);
  const load = useCallback((signal) => fetchOverview(academyId, signal), [academyId]);
  const { data, error, updatedAt, loading, refresh } = usePolling(load, {
    intervalOf: overviewIntervalOf,
    enabled: academyId !== null,
    resetKey: academyId
  });

  useEffect(() => {
    setOverview({
      academyId,
      data,
      errorDetail: error ? problemDetailOf(error) : null,
      updatedAt,
      loading
    });
  }, [academyId, data, error, updatedAt, loading, setOverview]);

  useEffect(() => {
    if (refreshRequests === 0) {
      return undefined;
    }
    refresh();
    const settled = setTimeout(refresh, SERVER_CACHE_SETTLED_MS);
    return () => clearTimeout(settled);
  }, [refreshRequests, refresh]);

  return null;
};

export default GradingOverviewSync;
